<template>
  <div class="service-container">
    <div class="warpper">
      <div class="title">Green</div>
      <div class="content">
        <div class="content-info">在此特别提醒您(户)在注册成为Green加速器之前，请认真阅读本《Green加速器用户服务协议》(以下"简称"协议"), 确保您充分理解本协议中各条款。 请您审慎阅读并选择接受或不接受本协议。除非 您接受本协议所有条款，否则您无权注册、 登录或使用本协议所涉服务。您的注册、登录使用 等行为将视为对本协议的接受,同意接受本协议各项条款的约束。本协议约定Green加速器与用户之间关 于"SSR"服务(以下简称“服务")的权利义 务。“用户”是指注册、登录使用本服务的个人, Green加速器有权更新协议内容，，更新后的协议条款公布即替代原协议条款，恕不另行通知</div>
        <div class="subContent-info">账号注册</div>
        <div>1.用户在使用本服务前需要注册一个“Green加速器”账号。“Green加速器”账号应当使用邮箱或手机号绑定注册，用 户使用尚未与其他“Green加速器”账号绑定以及未被 Green加速器根据本协议封禁的邮箱注册“Green加速器”账 号。Green加速器有权根据用户需求或产品需要对账 号注册和绑定的方式进行变更，恕不再另行通 知。<br>
          2.如果注册申请者有被Green加速器封禁的先例或涉嫌 虚假注册及滥用他人名义注册，及其他不能得 到许可的理由，Green加速器有权拒绝向其提供服务。 </div>

        <div class="subContent-info">账户安全</div>
        <div> 1.户一旦注册成功，成为Green加速器的用户,将得到一个用户名和密码，有权利使用自己的用户名及密码随时登陆Green加速器。<br>
          2.用户对账户和密码的安全负全部责任，同时对其账户进行的所有活动和事件负全部责任。 <br>
          3.Green加速器未经户允许不得泄露用户的个人隐私与信息。<br>
          4.如果用户密码泄露或者其他任何原因导致用户的密码安全受到威胁，应该及时和Green加速器客服 人员取得联系，否则后果自负。
        </div>

        <div class="subContent-info">用户声明与保证</div>
        <div>
          1.户需具有完全民事行为能力，具有达成交 易履行其义务的能力。<br>
          2.通过使用Green加速器的过程中所制作、上载、 复制、发布、传播的任何内容,包括但不限于 账号头像、名称、户说明等注册信息及认证 资料，或文字、语音、图片视频、图文等发 送、回复和相关链接页面，以及其他使用账号或本服务所产生的内容，不得违反国家相关法 律制度，包含但不限于如下原则:<br>
          ①反对宪法所确定的基本原则的 <br>
          ②危害国家安全,泄露国家秘密，颠覆国家 政权，破坏国家统一的<br>
          ③损害国家荣誉和利益的 <br>
          ④煽动民族仇恨、民族歧视，破坏民族团结的 <br>
          ⑤破坏国家宗教政策，宣扬邪教和封建迷信的 <br>
          ⑥散布谣言,扰乱社会秩序,破坏社会稳定的 <br>
          ⑥散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的 <br>
          ⑦侮辱或者诽谤他人，侵害他人合法权益的 <br>
          ⑧含有法律、行政法规禁止的其他内容的 <br>
        </div>

        <div class="subContent-info">服务内容</div>
        <div>
          1.Green加速器具体服务内容由Green加速器根据实际情况提供，包括但不限于: <br>
          ①在线咨询服务 <br>
          ②网络代理服务 <br>
          2.所有发给用户的通告及其他消息都可通过邮箱 或者用户所提供的联系方式发送。 <br>
          3.本站无退款机制，不接受退款请求，新注册户请先试用。<br>
        </div>


        <div class="subContent-info">服务的终止</div>
        <div>
          1.在下列情况下，Green加速器有权终止向用户提供服务:<br>
          ①用户违反服务协议相关规定<br>
          ②半年以以上未使用“Green加速器"服务,Green加速器有权 终止向用户提供服务并不再保留用户相关数据 <br>
          ③用户不得通过“Green加速器”服务传播违反本协议 规定的内容, 一经发现，Green加速器有权扣留账 户内的金额 本服务条款终止或更新时，户明确表示不愿接受新的服务条款 <br>
          ④Green加速器认为需终止服务的情况 2.服务终止后,Green加速器没有义务为用户保留原账户或与之相关的任何信息。
        </div>

        <div class="subContent-info">服务变更、中断</div>
        <div>
          1.鉴于网络服务的特殊性，同意Green加速器会更新、中断部分或全部的网络服务, 并删除 (不再保存)用户在使用过程中提交的任何资料，无需告知用户，也无需对任何用户或任何第三方承担任何责任。<br>
          2.Green加速器需要定期或不定期地对提供网络服务的平台进行检测或者更新，造成网络服务在合理 时间内的中断，Green加速器有义务进行提前通知，除此之外Green加速器无需为此承担任何责任。<br>
        </div>

        <div class="subContent-info">服务的条款修改</div>
        <div>
          1.Green加速器有权随时修改本服务条款的任何内容, 一旦本服务条款的任何内容发生变动，Green加速器 将会通过适当方式向用户提示修改内容。<br>
          2.如果不同意Green加速器对本服务条款所做的更新及改动，用户有权停止使用Green加速器服务。<br>
          3.如果用户继续使用网络服务，则视为用户接授Green加速器对本服务条款所做的修改。<br>
        </div>

        <div class="subContent-info">免责与赔偿声明</div>
        <div>
          1.若Green加速器已经明示其服务提供方式发生变更并 提醒用户应当注意事项，如因此类情况而用 户未按要求操作所产生的一切后果由用户自行承担。<br>
          2.明确同意其使用Green加速器所存在的风险将完全由其自己承担，因其使用Green加速器产生的一切后果也由其自己承担。<br>
          3.用户同意保障和维护Green加速器及其他用户的利益，由于户在使用Green加速器有违法、不真实、 正当、侵犯第三方合法权益的行为，或用户 违板本协议项下的任何条款而给Green加速器及任何 其他第三方造成损失，用户同意承担由此造成 的损害赔偿责任。<br>
        </div>

        <div class="subContent-info">其他</div>
        <div>
          1.Green加速器郑重提醒用户注意本协议中免除Green加速器责任和限制用户权利的条款，请用户仔细阅读, 自主考虑风险。未成年，人应在法定监护人的陪 同下阅读本协议。<br>
          2.本协议最终解释权归Green加速器所有，粗保留一切解释和修改的权力。<br>
          3.本协议从即日起2024年02月01日起适用。<br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[]
    };
  },
  methods:{
      get_list(){
         var service_list = [
           {'title':'特别提示','content':'在此特别提醒您(户)在注册成为Green之前，请认真阅读本《Green用户服务协议》(以下"简称"协议"), 确保您充分理解本协议中各条款。 请您审慎阅读并选择接受或不接受本协议。除非 您接受本协议所有条款，否则您无权注册、 登录或使用本协议所涉服务。您的注册、登录使用 等行为将视为对本协议的接受,同意接受本协议各项条款的约束。本协议约定Green与用户之间关 于"SSR"服务(以下简称“服务")的权利义 务。“用户”是指注册、登录使用本服务的个人, Green有权更新协议内容，，更新后的协议条款公布即替代原协议条款，恕不另行通知。'},
           {'title':'账号注册','content': ' 1.用户在使用本服务前需要注册一个“Green”账号。“Green”账号应当使用邮箱或手机号绑定注册，用 户使用尚未与其他“Green”账号绑定以及未被 Green根据本协议封禁的邮箱注册“Green”账 号。Green有权根据用户需求或产品需要对账 号注册和绑定的方式进行变更，恕不再另行通 知。<br> 2.如果注册申请者有被Green封禁的先例或涉嫌 虚假注册及滥用他人名义注册，及其他不能得 到许可的理由，Green有权拒绝向其提供服务。 '}
         ]
        this.list = service_list
      }
  },
  created() {
    this.get_list()
  }
}
</script>
<style scoped>
.service-container .warpper{
  padding: 0 2.666667vw 0 2.666667vw;
  background: #f4f6f9;
  padding-bottom: 10.666667vw;
}
.service-container .warpper .title{
  font-size: 6.666667vw;
  margin-top: 6.666667vw;
  font-weight: 700;
  text-align: center;
}
.service-container .warpper .content{
  margin-top: 6.666667vw;
  background-color: #fff;
  border-radius: 1.333333vw;
  padding: 1.333333vw 2.666667vw;
  border-top: 0.666667vw solid #6777ef;
}
.service-container .warpper .content .content-info{
  font-size: 4.8vw;
  font-weight: 700;
  margin-top: 2.666667vw;
  color: #6777ef;
  margin-bottom: 4vw;
}
.service-container .warpper .content .subContent-info{
  margin-top: 2.666667vw;
  margin-bottom: 2.666667vw;
  font-weight: 700;
  margin-top: 1.333333vw;
  font-size: 4vw;
  color: #6c757d;
}
.service-container .warpper .content div{
  font-size: 3.733333vw;
  margin-top: 1.333333vw;
  color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/view/service.vue